import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import PromotionBar from "./snippets/PromotionBar";
import ModulesLotteryDraw from "./promotions/promotion_modules/modules_lotterDraw";
import { usePromotionsPage, hiddenBtnTitles } from "./data/usePromotionsPage";
import { useLocation, useSearchParams } from "react-router-dom";
import ModulesPeraBayong from "./promotions/promotion_modules/modules_peraBayong";
import ModuleJiliGrandSlot from "./promotions/promotion_modules/ModuleJiliGrandSlot";
import RollingCommission from "./promotions/RollingCommission";
import JiliQuest from "./snippets/games/JiliQuest";
import ScrollLoader from "./snippets/games/ScrollLoader";
import RiseOfHeroesGame from "./snippets/games/RiseOfHeroesGame";
import { useSchedule } from "./data/ScheduleContext";

const modalComponents = {
	"2/30 Lottery Draw": ModulesLotteryDraw,
	"Jili Grand Slot": ModuleJiliGrandSlot,
	"Pera O Bayong": ModulesPeraBayong,
};

export default function AppPromo({ isLightMode }) {
	const {
		uniqueFilters,
		isMobile,
		currentFilter,
		handleFilterChange,
		isAnimating,
		filteredPromotions,

		isLoggedIn,
		showMysteryFridayBtn,
		doubleUpMaxAmount,
		doubleUpTurnover,

		setIsDepositOpen,
		setIsShowDoubleUp,
		setIsShowViewEntry,

		ActiveModal,
		setActiveModal,
		handlePeraOBayong,
		handleLeaderboard,
		handlePrimaryBtnClick,
	} = usePromotionsPage({
		modalComponents,
	});

	const [showRolling, setShowRolling] = useState(false);
	const [isJiliQuestOpen, setIsJiliQuestOpen] = useState(false);

	const handleCloseJiliQuest = () => {
		setIsJiliQuestOpen(false);

		if (searchParams.get("open") === "jili-quest") {
			const nextParams = new URLSearchParams(searchParams);

			nextParams.delete("open");

			setSearchParams(nextParams, {
				replace: true,
			});
		}
	};

	const [loading, setLoading] = useState(true);
	const [showGame, setShowGame] = useState(false);
	const { isVisible } = useSchedule();

	const location = useLocation();
	const isAppPromo = location.pathname.startsWith("/app-promotion");

	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		const open = searchParams.get("open");

		if (open === "jili-quest") {
			setIsJiliQuestOpen(true);
		}
	}, [searchParams]);

	useEffect(() => {
		const isAppPromotion = location.pathname.startsWith("/app-promotion");

		if (isAppPromotion) {
			const theme = isLightMode ? "light" : "dark";
			document.documentElement.dataset.theme = theme;
			localStorage.setItem("theme", theme);
		}
	}, [location.pathname]);

	const handleShowGame = () => {
		setLoading(true);
		setShowGame(true);

		setTimeout(() => {
			setLoading(false);
		}, 3000);
	};

	return (
		<>
			{ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}

			<div className="main-body-content promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-page-content">
						<h1 className="fgh-h1-style normal-margin-bottom">
							Exclusive Casino Bonuses Just for You
						</h1>
						<label className="fgh-normal-label-style standard-margin-bottom">
							Your Offers Are In – Don’t Miss Out
						</label>

						{!!uniqueFilters.length && (
							<div className="promotion-page-filter">
								{isMobile ? (
									<select
										value={currentFilter}
										onChange={(e) => handleFilterChange(e.target.value)}
									>
										{uniqueFilters.map((f, i) => (
											<option key={i} value={f}>
												{f}
											</option>
										))}
									</select>
								) : (
									<ul>
										{uniqueFilters.map((f, i) => (
											<li
												key={i}
												className={`promotion-filter-status ${
													currentFilter === f ? "active" : ""
												}`}
												onClick={() => handleFilterChange(f)}
											>
												{f}
											</li>
										))}
									</ul>
								)}
							</div>
						)}

						<div
							className={`promotion-items-container ${
								isAnimating ? "promotion-fade-out" : "promotion-fade-in"
							}`}
						>
							{filteredPromotions.map((data) => {
								const showBtn =
									!!data.btnTxt &&
									isLoggedIn &&
									!hiddenBtnTitles.has(data.title);

								const canPlayDoubleUp =
									data.title === "Double Up" &&
									isLoggedIn &&
									doubleUpMaxAmount &&
									doubleUpTurnover >= 100000;

								return (
									<div key={data.id} className="promotion-item">
										<div className="promotion-image">
											<img src={data.imgSrc} alt={data.title} />
											<div className="promotion-image-overlay" />
										</div>

										{data.status && (
											<div
												className={`promotion-item-ribbon ${data.promotionMessage.class}`}
											>
												{data.promotionMessage.text}
											</div>
										)}

										<div className="promotion-item-content">
											<div className="promotion-info">
												<h2>{data.title}</h2>
												<label>{data.subHeading}</label>
											</div>

											<div className="promotion-cta">
												{showMysteryFridayBtn &&
													data.title === "Pera O Bayong" && (
														<button onClick={handlePeraOBayong}>
															Claim Your Prize
														</button>
													)}

												{isLoggedIn &&
													data.title === "Jili Quest" &&
													!isAppPromo && (
														<button
															type="button"
															onClick={() => setIsJiliQuestOpen(true)}
														>
															View Game
														</button>
													)}

												{isLoggedIn &&
													!isAppPromo &&
													["Rise Of Heroes"].includes(data.title) && (
														<>
															{isVisible ? (
																<button onClick={handleShowGame}>
																	View Game
																</button>
															) : null}
														</>
													)}

												{isLoggedIn &&
													!isAppPromo &&
													[
														"King of the Reels",
														"FC Grand Spin-Ale",
														"Flexi-Spin Showdown",
														"CQ9 Funalo",
														"JDB Exclusive Promo",
														"Race of Reels: Slots Tournament",
														"BNG Splash Spin Into Summer",
														"Jili Grand Slot",
													].includes(data.title) && (
														<button
															onClick={() => handleLeaderboard(data.title)}
														>
															Leaderboard
														</button>
													)}

												{isLoggedIn && data.title === "8PM Recovery Hour" && (
													<button
														style={{ cursor: "pointer" }}
														onClick={() => setIsDepositOpen(true)}
													>
														Deposit Now
													</button>
												)}

												{canPlayDoubleUp && (
													<button
														onClick={() => {
															setIsShowDoubleUp(false);
															setTimeout(() => setIsShowDoubleUp(true), 0);
														}}
													>
														Play Now
													</button>
												)}

												{data.title === "8's Your Lucky Draw" && isLoggedIn && (
													<button onClick={() => setIsShowViewEntry(true)}>
														View Entry
													</button>
												)}

												{data.title === "Exclusive Rolling Commission" &&
													!isAppPromo &&
													isLoggedIn && (
														<button
															onClick={() => setShowRolling(!showRolling)}
														>
															View
														</button>
													)}

												{!!data.btnTxt && (
													<>
														{data.title === "Saturday Spin Surprize" && (
															<PromotionBar />
														)}

														{showBtn && !isAppPromo && (
															<button
																style={{ display: showBtn ? "block" : "none" }}
																onClick={() => handlePrimaryBtnClick(data)}
															>
																{data.btnTxt}
															</button>
														)}
													</>
												)}

												<a
													href={
														isAppPromo
															? data.tncLink.replace(
																	"/promotion",
																	"/app-promotion",
																)
															: data.tncLink
													}
												>
													Details
												</a>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
			{showRolling && (
				<RollingCommission onClose={() => setShowRolling(false)} />
			)}
			{isJiliQuestOpen &&
				createPortal(
					<div className="jili-quest-modal" role="dialog" aria-modal="true">
						<JiliQuest onClose={handleCloseJiliQuest} />
					</div>,
					document.body,
				)}
			{showGame &&
				createPortal(
					loading ? (
						<ScrollLoader />
					) : (
						<RiseOfHeroesGame onClose={() => setShowGame(false)} />
					),
					document.body,
				)}
		</>
	);
}
